module.exports = __webpack_public_path__ + "img/xihongshi.014cabdb.png";